import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import PageHeader from '../../components/pageHeader/pageHeader'
import PagedTable from '../../components/dataTable/pagedTable'
import RemoteValue from '../../components/remoteValues/remoteValue'

import AddCompanyModal from '../../components/modals/addCompanyModal'
import Period from '../../components/period'
import SearchBox from '../../components/search/searchBox'

const PageContent = styled.div`
  margin: 0px 50px 50px 50px;
`

const Name = styled.p`
  font-size: 1.3em;
  margin-bottom: 3px;
  font-weight: bold;
`

const Sub = styled.div`
  color: #61605f;

  p {
    line-height: 22px;
  }
`

const SearchCompanies = () => (
  <SearchBox
    collection="companies"
    render={({ name, website, address, lastEvent }) => (
      <React.Fragment>
        <Name>{name}</Name>
        <Sub>
          <p>
            {address} <br />
            {website}
          </p>

          <p>
            <b>Last Touch:</b> <Period date={lastEvent} />
          </p>
        </Sub>
      </React.Fragment>
    )}
  />
)

const Companies = () => {
  document.title = 'Companies'

  const history = useHistory()

  const [showAddModal, setShowAddModal] = useState(false)

  const handleCreated = (c) => {
    history.push(`/companies/${c._id}`)
  }

  return (
    <React.Fragment>
      <PageHeader
        breadcrumb={[
          { text: 'Dashboard', link: '/' },
          { text: 'Companies', link: '/companies' },
        ]}
        title="Companies"
        sub="One screen to partner them all."
        search={<SearchCompanies />}
        actions={
          <React.Fragment>
            <Button basic onClick={() => setShowAddModal(true)}>
              <Icon name="add" /> Add Company
            </Button>
          </React.Fragment>
        }
      />

      <PageContent>
        <PagedTable
          onRowClick={(item) => window.open(`/companies/${item._id}`, '_blank')}
          defaultSort="lastUpdateOn"
          collection="companies"
          columns={[
            {
              title: 'Name',
              field: 'name',
              width: 300,
              sortable: true,
            },
            {
              title: 'Website',
              field: 'website',
              render: (website) => (
                <a rel="noreferrer" href={website} target="_blank">
                  {website}
                </a>
              ),
              sortable: true,
            },
            {
              title: 'Linkedin',
              field: 'linkedin',
              render: (linkedin) => (
                <a rel="noreferrer" href={linkedin} target="_blank">
                  {linkedin}
                </a>
              ),
              sortable: true,
            },
            {
              title: 'Timezone',
              field: 'timezoneId',
              render: (timezoneId) => (
                <RemoteValue
                  collection="timezones"
                  id={timezoneId}
                  key={timezoneId}
                  predicate={(x) => x.text}
                />
              ),
              sortable: true,
            },
            {
              title: 'Last Update',
              field: 'lastUpdateOn',
              render: (lastUpdate) => <Period date={lastUpdate} />,
              sortable: true,
            },
          ]}
        />
      </PageContent>

      <AddCompanyModal
        open={showAddModal}
        onCancel={() => setShowAddModal(false)}
        onCreated={handleCreated}
      />
    </React.Fragment>
  )
}

export default Companies
